/**
 * @generated SignedSource<<496b87f77bc9530895b41189ee222e33>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type OnboardingPhotosScreenQuery$variables = Record<PropertyKey, never>;
export type OnboardingPhotosScreenQuery$data = {
  readonly " $fragmentSpreads": FragmentRefs<"OnboardingPhotosView_query">;
};
export type OnboardingPhotosScreenQuery = {
  response: OnboardingPhotosScreenQuery$data;
  variables: OnboardingPhotosScreenQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "kind": "Literal",
    "name": "filter",
    "value": {
      "type": {
        "equalTo": "PROFILE"
      }
    }
  },
  {
    "kind": "Literal",
    "name": "first",
    "value": 10
  }
],
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "OnboardingPhotosScreenQuery",
    "selections": [
      {
        "args": null,
        "kind": "FragmentSpread",
        "name": "OnboardingPhotosView_query"
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "OnboardingPhotosScreenQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "User",
        "kind": "LinkedField",
        "name": "currentUser",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "Profile",
            "kind": "LinkedField",
            "name": "profile",
            "plural": false,
            "selections": [
              {
                "alias": "profilePhotos",
                "args": (v0/*:: as any*/),
                "concreteType": "PhotoConnection",
                "kind": "LinkedField",
                "name": "photos",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "PhotoEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "cursor",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "Photo",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "description",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "rowId",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "sequence",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "StorageObject",
                            "kind": "LinkedField",
                            "name": "storageObject",
                            "plural": false,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "blurhash",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "bucket",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "key",
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          },
                          (v1/*:: as any*/),
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "__typename",
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "PageInfo",
                    "kind": "LinkedField",
                    "name": "pageInfo",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "endCursor",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "hasNextPage",
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  {
                    "kind": "ClientExtension",
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "__id",
                        "storageKey": null
                      }
                    ]
                  }
                ],
                "storageKey": "photos(filter:{\"type\":{\"equalTo\":\"PROFILE\"}},first:10)"
              },
              {
                "alias": "profilePhotos",
                "args": (v0/*:: as any*/),
                "filters": [
                  "filter"
                ],
                "handle": "connection",
                "key": "useProfilePhotos_profile_profilePhotos",
                "kind": "LinkedHandle",
                "name": "photos"
              },
              (v1/*:: as any*/)
            ],
            "storageKey": null
          },
          (v1/*:: as any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "869ed84ddd3610b1b8382877626e5612",
    "id": null,
    "metadata": {},
    "name": "OnboardingPhotosScreenQuery",
    "operationKind": "query",
    "text": "query OnboardingPhotosScreenQuery {\n  ...OnboardingPhotosView_query\n}\n\nfragment OnboardingPhotosView_query on Query {\n  currentUser {\n    profile {\n      ...useProfilePhotos_profile\n      id\n    }\n    id\n  }\n}\n\nfragment useProfilePhotos_profile on Profile {\n  profilePhotos: photos(first: 10, filter: {type: {equalTo: PROFILE}}) {\n    edges {\n      cursor\n      node {\n        description\n        rowId\n        sequence\n        storageObject {\n          blurhash\n          bucket\n          key\n        }\n        id\n        __typename\n      }\n    }\n    pageInfo {\n      endCursor\n      hasNextPage\n    }\n  }\n  id\n}\n"
  }
};
})();

(node as any).hash = "0aefb0b4a7ad6e984c31f4faded0705a";

export default node;
